var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main-container"},[_c('top-head'),_c('side-nav',{attrs:{"navShow":_vm.navShow},on:{"update:navShow":function($event){_vm.navShow=$event},"update:nav-show":function($event){_vm.navShow=$event}}}),_c('section',{staticClass:"wrapper",class:{'collpase':!_vm.navShow}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }